import { CALL_API } from '../../middleware/api';
import config from '../../config';
import { unwrap } from '../../utils/ChangeSpy';

export const SHOW_HARVCO_TAGS_LOADING = Symbol('SHOW_HARVCO_TAGS_LOADING');
export const REQUEST_API_HARVCO_TAGS_FAILURE = Symbol('REQUEST_API_HARVCO_TAGS_FAILURE');
export const LOADED_HARVCO_TAGS_SUCCESS = Symbol('LOADED_HARVCO_TAGS_SUCCESS');
export const INSERT_HARVCO_TAG_ROW = Symbol('INSERT_HARVCO_TAG_ROW');
export const CHANGE_HARVCO_TAG_ROW_MODE = Symbol('CHANGE_HARVCO_TAG_ROW_MODE');
export const CHANGE_HARVCO_TAG_ROW = Symbol('CHANGE_HARVCO_TAG_ROW');
export const DELETED_HARVCO_TAG_ROW_SUCCESS = Symbol('DELETED_HARVCO_TAG_ROW_SUCCESS');
export const SAVED_HARVCO_TAGS_SUCCESS = Symbol('SAVED_HARVCO_TAGS_SUCCESS');

/**
 * Load harvco tags information.
 *
 * @param id {Number} Ceo project's id.
 */
export function loadHarvcoTags(id) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/ceo_projects/${id}`,
      query: { include: 'harvco_tags' },
      startType: SHOW_HARVCO_TAGS_LOADING,
      errorType: REQUEST_API_HARVCO_TAGS_FAILURE,
      successType: LOADED_HARVCO_TAGS_SUCCESS,
    },
  };
}

/**
 * Save HarvcoTag's table.
 */
export function saveHarvcoTags() {
  return (dispatch, getState) => {
    const state = getState().eproject;
    const projectId = state.projectData.get('id');
    const harvco_tags = state.harvcoTags
      .map(tag => {
        if (tag.get('id') > 0) {
          return {
            ...tag.toJS(),
            tag: unwrap(tag.get('tag')),
          };
        }

        return {
          tag: unwrap(tag.get('tag')),
        };
      })
      .toJS();

    return dispatch({
      [CALL_API]: {
        method: 'post',
        path: `/api/v1/ceo_projects/${projectId}/bulk/harvco_tags`,
        body: { harvco_tags },
        startType: SHOW_HARVCO_TAGS_LOADING,
        errorType: REQUEST_API_HARVCO_TAGS_FAILURE,
        successType: SAVED_HARVCO_TAGS_SUCCESS,
      },
    }).then(() => dispatch(loadHarvcoTags(projectId)));
  };
}

/**
 * Insert a new harvco tag row into grid.
 */
export function insertHarvcoTagRow() {
  return {
    type: INSERT_HARVCO_TAG_ROW,
  };
}

/**
 * Switch a harvo tag row to edit mode.
 *
 * @param index {Number} Row index.
 */
export function switchHarvcoTagRowToEdit(index) {
  return {
    type: CHANGE_HARVCO_TAG_ROW_MODE,
    index,
    mode: config.EDIT_MODE,
  };
}

/**
 * Action for updating harvco tag's text input.
 */
export function updateHarvcoTag(index, name, value) {
  return {
    type: CHANGE_HARVCO_TAG_ROW,
    index,
    name,
    value,
  };
}

/**
 * Delete a harvco tag row.
 *
 * @param id {Number} Row id.
 */
export function deleteHarvcoTagRow(id) {
  return (dispatch, getState) => {
    const projectId = getState().eproject.projectData.get('id');

    dispatch({
      [CALL_API]: {
        method: 'delete',
        path: `/api/v1/ceo_projects/${projectId}/harvco_tags/${id}`,
        startType: SHOW_HARVCO_TAGS_LOADING,
        errorType: REQUEST_API_HARVCO_TAGS_FAILURE,
        afterSuccess: ({ dispatch }) => {
          dispatch(loadHarvcoTags(projectId));
        },
        afterError: ({ dispatch }) => dispatch(loadHarvcoTags(projectId)),
      },
    });
  };
}
